import type { AdminDashboard } from '../api/admin.api'

export function dashboardOperationalRates(global: AdminDashboard['payments']['global']) {
  const base = global.paidCount + global.refundedCount + global.chargedBackCount
  const format = (count: number) =>
    base > 0
      ? `${((count / base) * 100).toLocaleString('pt-BR', { maximumFractionDigits: 2 })}%`
      : 'Sem base'
  return {
    base,
    chargebacks: format(global.chargedBackCount),
    refunds: format(global.refundedCount),
  }
}
